import { createFileRoute } from '@tanstack/react-router'
import { ProductEditor } from './-ProductEditor'

export const Route = createFileRoute('/products/$id')({
  component: ProductDetailPage,
})

function ProductDetailPage() {
  const { id } = Route.useParams()
  return <ProductEditor id={id} />
}
